import React from 'react'
import PropTypes from 'prop-types'

import Progress from '../../Progress/Progress'

export const SearchResults = ({ restaurants = [], loading }) => {
  if (loading) return <Progress eventData={{ category: 'Multi Location Search Results' }} />
  if (!restaurants.length) return <p>no restaurants</p>

  return (
    <ul>
      {restaurants.map(({ whiteLabelName, guid, shortUrl }) => (
        <li key={guid}><a href={`/${shortUrl}/v3`}>{whiteLabelName}</a></li>
      ))}
    </ul>
  )
}

SearchResults.propTypes = {
  restaurants: PropTypes.array,
  loading: PropTypes.bool
}
